export default __webpack_public_path__ + "static/media/body-section-abductors.56ff1a96.png";